/* eslint-disable no-console */
import { cohesionEvents } from "shared/components/Cohesion/constants/events";

// Map of event Names to cohesion
const eventNameMap = {
  [cohesionEvents.elementClicked]: "ElementClicked",
  [cohesionEvents.elementViewed]: "ElementViewed",
  [cohesionEvents.elementSwiped]: "ElementSwiped",
};

const eventsQueue = [];
let queuePid = null;

function enqueue(eventData) {
  eventsQueue.push(eventData);

  if (!queuePid) {
    queuePid = setInterval(() => {
      if (typeof window !== "undefined" && "tagular" in window) {
        clearInterval(queuePid);
        // eslint-disable-next-line no-use-before-define
        eventsQueue.forEach(track);
      }
    }, 250);
  }
}

/**
 * Main tracking function that fires a tagular beam event if
 * cohesion tagular is on the page.
 */
export const track = ({ eventName, properties }) => {
  const event = eventNameMap[eventName];

  if (!event) console.error(`${eventName} is not a supported event`);

  const clientTrackingPayload = {
    "@type": eventName,
    ...properties,
  };

  if (process.env.NODE_ENV === "production") {
    // in Production
    // if tagular is loaded onto the page then fire the beam event
    if (typeof window !== "undefined" && "tagular" in window) {
      try {
        window.tagular("beam", event, clientTrackingPayload);
      } catch (e) {
        console.error(e);
      }
    } else {
      console.warn("tagular not found");
      enqueue({ eventName, properties });
    }
  } else {
    // in QA and Staging
    // console out the tagular event we will send to prod
    console.groupCollapsed(
      "%cCohesion:",
      "background: #2980b9; color: #fff; padding: 3px; font-weight: 700;",
      eventName
    );
    Object.entries(clientTrackingPayload).forEach(([key, value]) => {
      console.log(key, ":", value);
    });
    console.groupEnd();
  }
};
